module.exports = __webpack_public_path__ + "img/appStore-gray.a74af765.png";